<template>
  <div>
    <label :for="inputName">{{inputLabel}}</label>
    <input
      :disabled="disabled"
      :class="inputComputedClassName"
      :type="inputType"
      :name="inputName"
      :value="inputValue"
      :maxlength="maxlength"
      @input="validateAndSetInput"
    >
    <span v-if="!isValid">{{errorText}}</span>
    <span v-if="showMaxLengthError" class="maxlength-error">Nu poți adăuga mai mult de 10 caractere</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMaxLengthError: false
    }
  },
  props: {
    inputType: String,
    inputName: String,
    inputLabel: String,
    inputValue: String,
    setInput: Function,
    isValid: Boolean,
    disabled: Boolean,
    errorText: String,
    maxlength: {
      type: String,
      default: null
    }
  },
  computed: {
    inputComputedClassName: function() {
      return this.isValid ? "" : " error";
    }
  },
  methods: {
    validateAndSetInput(event) {
      if (this.maxlength) {
        if (event.target.value.length >= parseInt(this.maxlength)) {
          event.target.value = event.target.value.slice(0, parseInt(this.maxlength));
          this.showMaxLengthError = true;
        } else {
          this.showMaxLengthError = false;
        }
      }
      this.setInput(event);
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.4;
}

input {
  display: block;
  padding: 11px 16px;
  height: 44px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  transition: all 0.2s ease;
  background-color: #f8fafc;
  color: #1a1a1a;
  
  &::placeholder {
    color: #94a3b8;
  }
  
  &:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
  }
  
  &:focus {
    outline: none;
    border-color: #bd1f23;
    background-color: #fff;
    box-shadow: 0 0 0 1px rgba(189, 31, 35, 0.1);
  }
  
  &:disabled {
    background-color: #f1f5f9;
    cursor: not-allowed;
    color: #94a3b8;
    border-color: #e2e8f0;
  }
  
  &.error {
    border-color: #bd1f23;
    background-color: #fff;
    
    &:focus {
      border-color: #bd1f23;
      box-shadow: 0 0 0 1px rgba(189, 31, 35, 0.1);
    }
  }
}

span {
  display: block;
  margin: 6px 0 0 0;
  color: #bd1f23;
  font-size: 14px;
}

.maxlength-error {
  font-size: 14px;
  font-style: italic;
  color: #bd1f23 !important;
}

.hide {
  display: none;
}

.show {
  display: block;
}
</style>

